module.exports = __webpack_public_path__ + "img/pageCountArrow.033beb91.svg";